import EventApi from '@apis/event/EventApi';
import queries from '@apis/queries';
import { GetEventsParams } from '@models/event/request';
import { useInfiniteQuery } from '@tanstack/react-query';
import { getFlattenPageResponse, getIsBlank, getNextPageParam } from '@utils/pageable';

function useEvents() {
    const params: Omit<GetEventsParams, 'page'> = {
        sorter: 'CreatedAtDesc', size: 10,
    };
    const queryInfo = useInfiniteQuery({
        queryKey: queries.events.list(params).queryKey,
        queryFn: ({ pageParam }) => EventApi.getEvents({
            ...params,
            page: pageParam,
        }),
        initialPageParam: 0,
        getNextPageParam,
    });
    const events = getFlattenPageResponse(queryInfo);
    const isBlank = getIsBlank(queryInfo);

    return {
        ...queryInfo,
        events,
        isBlank,
    };
}

export default useEvents;
